import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import VueScrollReveal from 'vue-scroll-reveal';
import VueI18n from "vue-i18n";
import i18n from "@/i18n";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import wb from "./registerServiceWorker";
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import iranMap from 'iran-map-vue';
import VueMeta from 'vue-meta'
import VueImg from 'v-img';
Vue.use(VueImg);
Vue.use(VueMeta)
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('iran-map-vue', iranMap);

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 800,
  scale: 1,
  distance: '10px',
  mobile: false
});

Vue.prototype.$workbox = wb;
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.config.productionTip = false

Vue.use(VueI18n);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
